import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { GalleryService, UtilService } from '../../shared/services';

@Component({
  selector: 'app-doc-slides',
  templateUrl: './doc-slides.component.html',
  styleUrls: ['./doc-slides.component.scss']
})
export class DocSlidesComponent implements OnInit, AfterViewInit {

  @Input() slides: any[];
  isMobile: any;

  constructor(
    public util: UtilService,
    private galleryService: GalleryService
  ) {
    this.isMobile = this.util.isMobile();
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (typeof window !== 'undefined') {
        const glides = document.getElementsByClassName('glide__slides');
        for (let i = 0; i < glides.length; i++) {
          if (glides[i].getElementsByClassName('lightgallerydocs').length > 0) {
            glides[i].setAttribute('id', 'lightgallerydocs');
          }
        }
        this.galleryService.initGallery('lightgallerydocs');
      }
    }, 10);
  }

}
